import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { C, card, label, btn, input } from "../lib/theme";

const TIERS = ["24h","7d","30d","90d","permanent","ban"];

export default function Moderation() {
  const [q, setQ] = useState(null);
  const [notes, setNotes] = useState({});
  const [tier, setTier] = useState({});
  const [thread, setThread] = useState(null);
  const [history, setHistory] = useState(null);
  const [msg, setMsg] = useState("");
  const [digest, setDigest] = useState(null);
  const [titleForm, setTitleForm] = useState({ name: "", title: "" });
  const [pins, setPins] = useState([]);
  const [news, setNews] = useState([]);
  const [newsForm, setNewsForm] = useState({ id: null, title: "", body: "" });
  const load = () => {
    api.modQueue().then(setQ);
    api.findingsDigest().then(setDigest).catch(() => {});
    api.board().then((ps) => setPins(ps.filter((p) => p.pinned || p.locked)));
    api.modNews().then(setNews).catch(() => {});
  };
  useEffect(load, []);
  const act = (fn) => fn().then(() => { setMsg(""); load(); }).catch((e) => setMsg(e.message));
  if (!q) return <div style={{ color: C.faint }}>Loading queue…</div>;

  const Prior = ({ label: lbl, p, warn }) => (
    <div style={{ fontSize: 11, color: C.dim, marginBottom: 2 }}>
      {lbl} — {p.total !== undefined
        ? `${p.total} prior (${p.actioned} actioned · ${p.dismissed} dismissed)`
        : `${p.filed} filed${p.dismissal_rate !== null ? `, ${Math.round(p.dismissal_rate * 100)}% dismissed` : ""}`}
      {warn && <span style={{ color: C.rose }}> · {warn}</span>}
    </div>
  );

  const Item = ({ r, kind }) => {
    const subject = kind === "post" ? r.author : r.sender;
    return (
      <div style={{ ...card, marginBottom: 12 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "baseline" }}>
          <span style={{ fontSize: 9.5, letterSpacing: "0.1em", color: C.bg,
            background: C.brass, borderRadius: 3, padding: "1px 6px" }}>
            {kind === "post" ? "POST" : "DM"}</span>
          <span style={{ fontSize: 12.5 }}>"{r.reason}"</span>
          <span style={{ marginLeft: "auto", fontSize: 10.5, color: C.faint }}>by {r.reporter || r.recipient}</span>
        </div>
        <div style={{ margin: "8px 0" }}>
          <Prior label={`Subject ${subject}`} p={r.author_prior}
            warn={r.author_prior.actioned >= 1 && r.author_prior.total >= 2 ? "pattern forming" : null} />
          <Prior label="Reporter" p={r.reporter_prior}
            warn={r.reporter_prior.dismissal_rate >= 0.6 ? "frequent reporter" : null} />
        </div>
        {kind === "post" && <div style={{ background: C.bg, border: `1px solid ${C.line}`,
          borderRadius: 6, padding: "8px 12px", fontSize: 12.5, marginBottom: 8 }}>
          <b>{r.title}</b><div style={{ color: C.dim, marginTop: 3 }}>{r.excerpt}</div></div>}
        {kind === "dm" && <button onClick={() => api.modThread(r.report_id).then(setThread)}
          style={{ all: "unset", cursor: "pointer", color: C.brass, fontSize: 12, marginBottom: 8,
            display: "block" }}>View reported thread (audit-logged)</button>}
        <input placeholder="Resolution note" value={notes[r.report_id] || ""}
          onChange={(e) => setNotes({ ...notes, [r.report_id]: e.target.value })}
          style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: 8 }} />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <button style={btn(false)} onClick={() =>
            act(() => api.modResolve(kind, r.report_id, "dismissed", notes[r.report_id]))}>Dismiss</button>
          <button style={btn()} onClick={() =>
            act(() => api.modResolve(kind, r.report_id, "actioned", notes[r.report_id]))}>Actioned</button>
          {kind === "post" && !r.removed && <button style={{ ...btn(false), color: C.rose,
            borderColor: C.rose }} onClick={() =>
            act(() => api.modRemove(r.post_id, notes[r.report_id] || "moderation"))}>Remove post</button>}
          <span style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
            <select value={tier[subject] || "24h"}
              onChange={(e) => setTier({ ...tier, [subject]: e.target.value })} style={input}>
              {TIERS.map((t) => <option key={t}>{t}</option>)}
            </select>
            <button style={{ ...btn(false), color: C.rose, borderColor: C.rose }} onClick={() =>
              act(() => api.modSuspend(subject, tier[subject] || "24h",
                notes[r.report_id] || "moderation"))}>Suspend</button>
            <button style={btn(false)} onClick={() => api.modHistory(subject).then(setHistory)}>
              History</button>
          </span>
        </div>
      </div>
    );
  };

  return (
    <div style={{ maxWidth: 780 }}>
      {digest && digest.rows > 0 && (
        <div style={{ ...card, borderColor: C.brass, marginBottom: 14 }}>
          <div style={label}>FINDINGS DIGEST — {digest.as_of} · RAW MATERIAL FOR YOUR
            LOCKED UPDATES TOPIC</div>
          <textarea readOnly value={digest.markdown} rows={10} onFocus={(e) => e.target.select()}
            style={{ ...input, width: "100%", boxSizing: "border-box",
              fontFamily: "ui-monospace,monospace", fontSize: 11.5, lineHeight: 1.5 }} />
          <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center" }}>
            <button style={btn(false)}
              onClick={() => navigator.clipboard?.writeText(digest.markdown)}>Copy markdown</button>
            <span style={{ fontSize: 10.5, color: C.faint }}>
              Nothing publishes automatically — trim it, add your commentary, and reply
              in the locked topic.</span>
          </div>
        </div>
      )}
      <div style={{ ...label }}>HOMEPAGE NEWS</div>
      <div style={{ ...card, padding: "12px 16px", marginBottom: 8 }}>
        <input placeholder="Headline" value={newsForm.title} maxLength={200}
          onChange={(e) => setNewsForm({ ...newsForm, title: e.target.value })}
          style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: 6 }} />
        <textarea placeholder="Body (plain text)" value={newsForm.body} rows={3} maxLength={5000}
          onChange={(e) => setNewsForm({ ...newsForm, body: e.target.value })}
          style={{ ...input, width: "100%", boxSizing: "border-box", resize: "vertical",
            fontFamily: "inherit" }} />
        <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center" }}>
          <button style={btn()} disabled={!newsForm.title.trim() || !newsForm.body.trim()}
            onClick={() => act(() => (newsForm.id
              ? api.modNewsUpdate(newsForm.id, { title: newsForm.title, body: newsForm.body })
              : api.modNewsCreate({ title: newsForm.title, body: newsForm.body }))
              .then(() => setNewsForm({ id: null, title: "", body: "" })))}>
            {newsForm.id ? "Save changes" : "Publish"}</button>
          {newsForm.id && <button style={btn(false)}
            onClick={() => setNewsForm({ id: null, title: "", body: "" })}>Cancel edit</button>}
          <span style={{ fontSize: 10.5, color: C.faint }}>
            Shows on every member's Home page immediately.</span>
        </div>
      </div>
      {news.map((n) => (
        <div key={n.id} style={{ display: "flex", gap: 10, alignItems: "baseline",
          padding: "5px 0", borderBottom: `1px solid ${C.line}`, fontSize: 12.5 }}>
          <span style={{ flexGrow: 1, color: C.dim }}>
            <b style={{ color: C.text }}>{n.title}</b>
            <span style={{ color: C.faint }}> · {String(n.published_at).slice(0, 10)}</span>
          </span>
          <button onClick={() => setNewsForm({ id: n.id, title: n.title, body: n.body })}
            style={{ all: "unset", cursor: "pointer", color: C.brass, fontSize: 11.5 }}>
            edit</button>
          <button onClick={() => { if (confirm(`Delete "${n.title}"?`))
              act(() => api.modNewsDelete(n.id)); }}
            style={{ all: "unset", cursor: "pointer", color: C.rose, fontSize: 11.5 }}>
            delete</button>
        </div>
      ))}
      <div style={{ ...label, marginTop: 16 }}>PINNED & LOCKED TOPICS</div>
      {pins.map((p) => (
        <div key={p.id} style={{ display: "flex", gap: 10, alignItems: "center",
          padding: "5px 0", borderBottom: `1px solid ${C.line}`, fontSize: 12.5 }}>
          <span style={{ flexGrow: 1, color: C.dim }}>
            {p.pinned && "📌 "}{p.locked && "🔒 "}{p.title}</span>
          <button onClick={() => (p.locked ? api.modUnlock(p.id) : api.modLock(p.id)).then(load)}
            style={{ all: "unset", cursor: "pointer", color: C.brass, fontSize: 11.5 }}>
            {p.locked ? "unlock" : "lock"}</button>
          <button onClick={() => (p.pinned ? api.modUnpin(p.id) : api.modPin(p.id)).then(load)}
            style={{ all: "unset", cursor: "pointer", color: C.brass, fontSize: 11.5 }}>
            {p.pinned ? "unpin" : "pin"}</button>
        </div>
      ))}
      <div style={{ ...label, marginTop: 16 }}>BESTOW A TITLE</div>
      <div style={{ ...card, padding: "12px 16px", marginBottom: 14 }}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <input placeholder="Display name" value={titleForm.name}
            onChange={(e) => setTitleForm({ ...titleForm, name: e.target.value })}
            style={{ ...input, width: 180 }} />
          <input placeholder="Custom title, e.g. Hellenistic Luminary" value={titleForm.title}
            onChange={(e) => setTitleForm({ ...titleForm, title: e.target.value })}
            style={{ ...input, flexGrow: 1, minWidth: 200 }} maxLength={40} />
          <button style={btn()} disabled={!titleForm.name || titleForm.title.length < 2}
            onClick={() => api.modSetTitle(titleForm.name, titleForm.title)
              .then(() => { setMsg(`Title bestowed on ${titleForm.name}.`);
                setTitleForm({ name: "", title: "" }); })
              .catch((e) => setMsg(e.message))}>Bestow</button>
          <button style={btn(false)} disabled={!titleForm.name}
            onClick={() => api.modSetTitle(titleForm.name, null)
              .then(() => setMsg(`${titleForm.name} restored to the earned ladder.`))
              .catch((e) => setMsg(e.message))}>Clear</button>
        </div>
        <div style={{ fontSize: 10.5, color: C.faint, marginTop: 6 }}>
          Custom titles display in brass with a ✶ and override the vote ladder; clearing
          restores the earned title. Audit-logged like every moderation action.
        </div>
      </div>
      <div style={{ ...label }}>OPEN REPORTS</div>
      {q.post_reports.length + q.dm_reports.length === 0 &&
        <div style={{ ...card, color: C.faint, fontSize: 12.5 }}>Queue is clear.</div>}
      {q.post_reports.map((r) => <Item key={"p" + r.report_id} r={r} kind="post" />)}
      {q.dm_reports.map((r) => <Item key={"d" + r.report_id} r={r} kind="dm" />)}
      {thread && (
        <div onClick={() => setThread(null)} style={{ position: "fixed", inset: 0,
          background: "rgba(6,8,16,0.7)", display: "flex", alignItems: "center",
          justifyContent: "center", zIndex: 40 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ ...card, width: 480, maxHeight: "80vh", overflow: "auto" }}>
            <div style={label}>REPORTED THREAD (DECRYPTED)</div>
            {thread.messages.map((m) => (
              <div key={m.id} style={{ border: `1px solid ${m.is_reported ? C.rose : C.line}`,
                background: m.is_reported ? "#2a1f2a" : C.bg, borderRadius: 6,
                padding: "8px 12px", marginBottom: 6, fontSize: 12.5 }}>
                <span style={{ fontSize: 10.5, color: C.faint }}>{m.sender}
                  {m.is_reported && <span style={{ color: C.rose }}> · reported</span>}</span>
                <div>{m.body}</div>
              </div>))}
          </div>
        </div>
      )}
      {history && (
        <div onClick={() => setHistory(null)} style={{ position: "fixed", inset: 0,
          background: "rgba(6,8,16,0.7)", display: "flex", alignItems: "center",
          justifyContent: "center", zIndex: 40 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ ...card, width: 520, maxHeight: "80vh", overflow: "auto" }}>
            <div style={label}>{history.user.toUpperCase()} — MODERATION HISTORY</div>
            <div style={{ fontSize: 12.5, marginBottom: 6 }}>
              As subject: {history.as_subject.summary.total} reports
              ({history.as_subject.summary.actioned} actioned · {history.as_subject.summary.dismissed} dismissed)
            </div>
            {history.as_subject.post_reports.map((r) => (
              <div key={r.report_id} style={{ fontSize: 11.5, color: C.dim,
                borderTop: `1px solid ${C.line}`, padding: "5px 0" }}>
                [{r.status}] {r.title} — "{r.reason}"{r.resolution_note && ` → ${r.resolution_note}`}
              </div>))}
            <div style={{ fontSize: 12.5, margin: "10px 0 6px" }}>
              As reporter: {history.as_reporter.summary.filed} filed
              {history.as_reporter.summary.dismissal_rate !== null &&
                `, ${Math.round(history.as_reporter.summary.dismissal_rate * 100)}% dismissed`}
            </div>
          </div>
        </div>
      )}
      {msg && <div style={{ color: C.rose, fontSize: 12 }}>{msg}</div>}
    </div>
  );
}
